module.exports = __webpack_public_path__ + "static/media/18ECA34.c871fe1c.jpg";